import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router';

import { routes } from '@/constants/routes';
import { contentsService } from '@/services/contents';
import StepperQuiz from '@/components/interactive/Quiz/StepperQuiz';

import QuizSummary from './QuizSummary';
import PrivacyNote from './PrivacyNote';

interface Props {
  quizData?: string;
  quizResponses?: string;
  contentInteractionId?: string;
  completed?: boolean;
  routeId?: string;
  contentId?: string;
}
const Quiz: React.FC<Props> = ({
  quizData,
  quizResponses,
  contentInteractionId,
  completed,
  routeId,
  contentId,
}) => {
  const navigate = useNavigate();

  const handleSaveUserResponses = useCallback(
    (userResponses: string) => {
      contentsService.updateContentInteraction(contentInteractionId, { quizResponses: userResponses });
    },
    [contentInteractionId],
  );

  const onExitQuiz = useCallback(() => {
    navigate(generatePath(routes.routes.detail, { routeId }));
  }, [navigate, routeId]);

  const onFinishQuiz = useCallback(() => {
    navigate(generatePath(routes.routes.content.complete, { routeId, contentId }));
  }, [contentId, navigate, routeId]);

  if (!completed) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'auto' }}>
        <PrivacyNote />
        <StepperQuiz
          quizData={quizData}
          responses={quizResponses}
          onFinishQuiz={onFinishQuiz}
          onExitQuiz={onExitQuiz}
          onSaveUserResponses={handleSaveUserResponses}
        />
      </div>
    );
  }

  return (
    <QuizSummary
      quizData={quizData}
      quizResponses={quizResponses}
      onSaveUserResponses={handleSaveUserResponses}
    />
  );
};

export default Quiz;
